import { useState, useEffect, useCallback } from "react";
import {
  THEME_KEY,
  THEME_EVENT,
  readMarketDarkMode,
  syncMarketTheme,
  dispatchThemeChange,
  injectGlobalThemeStyles,
} from "../styles/invelpsMarketTheme";

/** Mode jour / nuit centralisé pour toutes les pages marché */
export default function useInvelpsTheme() {
  const [darkMode, setDarkMode] = useState(readMarketDarkMode);

  useEffect(() => {
    injectGlobalThemeStyles();
    const apply = (e) => {
      const isDark = e?.detail?.isDark ?? readMarketDarkMode();
      setDarkMode(isDark);
      syncMarketTheme(isDark);
    };
    apply();
    window.addEventListener(THEME_EVENT, apply);
    const onStorage = (ev) => {
      if (!ev.key || ev.key === THEME_KEY) apply();
    };
    window.addEventListener("storage", onStorage);
    return () => {
      window.removeEventListener(THEME_EVENT, apply);
      window.removeEventListener("storage", onStorage);
    };
  }, []);

  const toggleDark = useCallback(() => {
    setDarkMode((prev) => {
      const next = !prev;
      try {
        window.localStorage.setItem(THEME_KEY, next ? "dark" : "light");
      } catch {
        /* ignore */
      }
      syncMarketTheme(next);
      dispatchThemeChange(next);
      return next;
    });
  }, []);

  return { darkMode, toggleDark, setDarkMode };
}
